<template>
  <div v-loading="loading" style="height: calc(100% - 80px);">
    <div class="item-list-part">
    <el-row :gutter="12" >
      <el-col
          :span="cols"
          v-for="(value, index) in props.materialList"
          :key="value.id"
          class="record-box"
      >

        <shopChatMaterialComponent
            :obj="value"
            :title="value.companyname"
            :indexnum="index"
            :imgUrl="myUtil.generateProductImg(value)"
            :btn-label="i18n.tkey('lang_buy')"
            :tag="'list'"
            :type="'primary'"
            @click-delete-shopchart = "deleteShopchart"
            @click-add-num= "addNumber"
            @click-subtract-num= "subtractNumber"
        />
      </el-col>
    </el-row>
      <el-row :gutter="12" style="text-align: left;padding: 16px;">
        <el-col
            :span="24"
        >
      <el-text >{{i18n.tkey("lang_transport")}}</el-text>
        </el-col>
      </el-row>

      <el-row :gutter="12" style="text-align: left;padding: 16px;">
        <el-col
            :span="6"
        >
          <el-text >{{i18n.tkey("lang_bill_username")}}</el-text>
        </el-col>
        <el-col
            :span="18"
        >
          <el-input
              type="text"
              v-model="clientName"
              autocomplete="off"></el-input>
        </el-col>

      </el-row>

      <el-row :gutter="12" style="text-align: left;padding: 16px;">
        <el-col
            :span="6"
        >
          <el-text >{{i18n.tkey("lang_bill_tel")}}</el-text>
        </el-col>
        <el-col
            :span="18"
        >
          <el-input
              type="text"
              v-model="clientPhone"
              autocomplete="off"></el-input>
        </el-col>

      </el-row>

      <el-row :gutter="12" style="text-align: left;padding: 16px;">
        <el-col
            :span="6"
        >
          <el-text >{{i18n.tkey("lang_d_address")}}</el-text>
        </el-col>
        <el-col
            :span="18"
        >
          <el-input
              type="text"
              v-model="clientArrs"
              autocomplete="off"></el-input>
        </el-col>

      </el-row>
    </div>
    <div class="total-part">
      <div class="text-part">
        <div>
          <span style="font-weight: 600" tkey="總金額">{{i18n.tkey("lang_bill_total")}}</span>
        </div>

        <div>
                    <span class="price-label">
                        &nbsp;
                        <span>${{curr}}{{totalSum}}</span>
                    </span>
        </div>
      </div>

      <div>
        <button class="submit-btn" @click="submitOrder" tkey="提交">{{i18n.tkey("lang_submit")}}</button>
      </div>
    </div>

  </div>
</template>
<script setup>

import myUtil from "@/util/util";
import {inject, onMounted, ref, toRef, watch} from "vue";
const i18n = inject("i18n")
import {useshopchartinfo} from "@/stores/shopchartinfo";
import { useUserinfo } from '@/stores/userinfo'
import ShopChatMaterialComponent from "@/components/shopchart/shopChatMaterialComponent.vue";
import boApi from "@/request/boApi";
const emits = defineEmits(["clickGoOrder", ])
const props = defineProps(["materialList","newTime","userInfoRef"])

const loading = ref(false)

// const userInfoRef = toRef(useUserinfo())
const useShopchartinfoRef = toRef(useshopchartinfo())

const cols = ref(24)

const curr = ref("HKD")

const totalSum = ref(0)

const clientName = ref("")

const clientPhone = ref("")

const clientArrs= ref("")


watch(() => props.newTime, (newValue, oldValue) => {
  changeTotal()
})
watch(() => props.userInfoRef.name, (newValue, oldValue) => {
  initdata()
})
function initdata(){
  clientName.value = props.userInfoRef.name

  clientPhone.value = props.userInfoRef.telephone

  clientArrs.value = props.userInfoRef.address
}
function changeTotal(){
  let numToal = 0.00
  for (let i = 0; i <props.materialList.length ; i++) {
      numToal +=  myUtil.MathFix(props.materialList[i].qty, props.materialList[i].cost , "*")
          curr.value = props.materialList[i].curr
  }
  totalSum.value = numToal
}

function  addNumber(index){
  props.materialList[index].qty +=1
  //useShopchartinfoRef.value.materialList[index].qty = materialList.value[index].qty
  changeTotal()
}

function subtractNumber(index){
  props.materialList[index].qty -=1
  if(props.materialList[index].qty  <1){
    props.materialList[index].qty = 1
  }
  //useShopchartinfoRef.value.materialList[index].qty = materialList.value[index].qty
  changeTotal()
}


function deleteShopchart(obj){
  for (let i = 0; i <props.materialList.length ; i++) {
    if(props.materialList[i].materialId === obj.materialId ){
      props.materialList.splice(i, 1);
     // useShopchartinfoRef.value.materialList.splice(i, 1);
      changeTotal()
      return
    }
  }
}

function submitOrder(){
  if(myUtil.isEmpty(clientName.value)||myUtil.isEmpty(clientPhone.value)||myUtil.isEmpty(clientArrs.value)){

    myUtil.alertWarning(i18n.tkey("lang_fillComplete"));
    return
  }
  console.log(useShopchartinfoRef.value.companyCode)
  console.log(useShopchartinfoRef.value.hid)
  loading.value = true
  insertHallBo()
}

function insertHallBo(){
  const request = boApi.insertNewHallBo
  const params = request.getParams()

  params.companycode = useShopchartinfoRef.value.companyCode
  params.addinfo3 = props.userInfoRef.login
  params.name = clientName.value
  params.telephone = clientPhone.value
  params.address = clientArrs.value
  params.orderref = useShopchartinfoRef.value.hid
  params.currinorder = curr.value

  params.boproducts = props.materialList

  request.send(params, (res) => {
    if (res.code == 200){
      loading.value = false
      var order = res.detail
      useShopchartinfoRef.value.materialList = []
      console.log(order)
      myUtil.alertSuccess(i18n.tkey("lang_apply_success"))
      emits("clickGoOrder",order)

    }else{
      loading.value = false
      myUtil.alertError(res.msg)
    }
  })

}


onMounted(() => {
  //if(materialList.value.length>0){
    changeTotal()
  initdata()
 // }
})

</script>
<style scoped>

.item-list-part {
  width: 100%;
  height: calc(100% - 98px);
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
}
.total-part {
  width: 100%;
  height: 65px;
  box-sizing: border-box;
  margin-top: 40px;
  line-height: 2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  padding: 8px;
}

.submit-btn {
  background: #e83f33;
  color: #fff;
  border: 1px solid #e83f33;
  font-size: 16px;
  font-weight: 600;
  padding: 8px 30px;
  border-radius: 3px;
  text-transform: uppercase;
}

.price-label {
  color: #e83f33;
}

.text-part {
  font-size: 16px;
  text-align: left;
}
</style>